import { toNumber } from '~/utils/helpers';
import { MaybeRefOrGetter, toValue } from "@vueuse/core";
import useRequest from "~/composables/useRequest";
import { GetProductCruiseListParam } from "~/services/model";
import { getCruiseList } from "~/services/product";
import { useRouteQuery } from "@/composables/router";
export function useProductCruiseList(
  param: MaybeRefOrGetter<GetProductCruiseListParam> = {}
) {
  const pageIndex = useRouteQuery<number>('page_index', 1, {
    transform: toNumber
  });
  const {state, execute, isLoading} = useRequest(
    () => getCruiseList({
      ...toValue(param),
      page_index: toValue(pageIndex),
      page_size: 10
    }),
    {
      page_index: 1,
      page_size: 10,
      total_page: 1,
      total_count: 1,
      page_count: 1,
      list: [],
    },
    {
      immediate: false,
      resetOnExecute: false
    }
  );

    const onPageChange = (page: number) => {
      pageIndex.value = page;
      execute(0);
    }
  return {
    state,
    pageIndex,
    isLoading,
    execute,

    onPageChange
  }
}
